'use strict';

const login = require('../base/login/login.js');
const formValidation = require('../base/components/formValidation');
const createErrorNotification = require('../base/components/errorNotification');
var processInclude = require('../base/util');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * disables a form
 * @param {form} $form - the form to disable
 * @param {boolean} disabled - disabled? yes or no
 */
function disableForm($form, disabled) {
    $.each($form.find('input, button, textarea, select'), function (index, value) {
        $(value).prop('disabled', disabled);
    });
}

/**
 * updates the html and run the javascript
 * @param {string} html the html string to fill the flow holder
 */
function updateLoginFlowHolder(html) {
    $('#login-flow-holder').html(html);
    processInclude(require('../components/formValidation'));
    processInclude(require('../components/clientSideValidation'));
}

login.checkEmail = function () {
    $(document).on('submit', 'form.check-email', function (e) {
        var $form = $(this);
        e.preventDefault();
        var url = $form.attr('action');
        $form.spinner().start();

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                $form.spinner().stop();
                if (!data.success) {
                    var $loginInput = $form.find('#check-email-form-email');
                    $loginInput.addClass('is-invalid');

                    if (data.message || data.didyoumean) {
                        $loginInput.parent().find('.invalid-feedback').html(data.didyoumean || data.message);
                    }
                    $(this).delay(5000).queue(function () {
                        $('.alert-danger').remove();
                    });
                } else {
                    updateLoginFlowHolder(data.templateAndForm.template);
                }
            },
            error: function (data) {
                disableForm($form, false);

                if (data.responseJSON.redirectUrl) {
                    window.location.href = data.responseJSON.redirectUrl;
                } else {
                    $form.spinner().stop();

                    $(this).delay(5000).queue(function () {
                        $('.alert-danger').remove();
                    });
                }
            }
        });

        return false;
    });
};

login.login = function () {
    $(document).on('submit', 'form.login', function (e) {
        var $form = $(this);
        e.preventDefault();
        var url = $form.attr('action');
        $form.spinner().start();
        $('form.login').trigger('login:submit', e);

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (!data.success) {
                    formValidation($form, data);
                    $('form.login').trigger('login:error', data);

                    disableForm($form, false);
                    $form.spinner().stop();

                    $(this).delay(5000).queue(function () {
                        $('.alert-danger').remove();
                    });
                } else {
                    $('form.login').trigger('login:success', data);
                    disableForm($form, true);
                    if (data.templateAndForm) {
                        updateLoginFlowHolder(data.templateAndForm.template);
                        if (data.templateAndForm.form === 'optinForm') {
                            $('#modalOptinInformation').modal('toggle');
                        }
                    } else {
                        location.href = data.redirectUrl;
                    }
                }
            },
            error: function (data) {
                disableForm($form, false);

                if (data.responseJSON.redirectUrl) {
                    window.location.href = data.responseJSON.redirectUrl;
                } else {
                    $('form.login').trigger('login:error', data);
                    $form.spinner().stop();

                    $(this).delay(5000).queue(function () {
                        $('.alert-danger').remove();
                    });
                }
            }
        });

        return false;
    });
};

login.close = function () {
    $('body').on('click', '.close', function () {
        $('body').find('.valid-feedback').removeClass('d-block').empty();
        $('body').find('.valid-submit-email').addClass('d-none');
        $('body').find('.request-password-body').removeClass('d-none');
    });
};

login.requestPasswordResetForm = function () {
    $(document).on('click', '#password-reset a', function (e) {
        e.preventDefault();
        var $clickedElement = $(e.target);
        var url = $clickedElement.attr('href');
        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $.spinner().stop();
                updateLoginFlowHolder(data.templateAndForm.template);
            },
            error: function () {
                $.spinner().stop();
            }
        });
        return false;
    });
};

login.resetPassword = function () {
    $(document).on('submit', '.reset-password-form, .account-activation-form', function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();
        $(form).find('.valid-feedback').removeClass('d-block').empty();
        $(e.target).trigger('login:register', e);

        var formData = form.serialize();
        var target = e.target.className.includes('reset-password-form') ? '#reset-password-email' : '#account-activation-email';
        if (!formData) {
            formData = 'loginEmail=' + $(target).val();
        }

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: formData,
            success: function (data) {
                form.spinner().stop();
                if (!data.success) {
                    formValidation(form, data);
                } else {
                    $(form).find('.valid-feedback').addClass('d-block').text(data.receivedMsgBody);
                    $(form).find('.valid-submit-email').removeClass('d-none');
                    $(form).find('.valid-email').text($(form).find(target).val());
                    $(form).find('.request-password-body').addClass('d-none');
                }
            },
            error: function () {
                form.spinner().stop();
            }
        });
        return false;
    });
};

login.didyoumean = function () {
    $('body').on('blur', '.did-you-mean-holder', function () {
        var url = $(this).data('url');
        var email = $(this).val();
        var $this = $(this);

        let urlParams = {
            email: email
        };

        var $wrapper = $this.parent();
        url = appendToUrl(url, urlParams);

        $this.removeClass('is-invalid');

        $wrapper.removeClass('is-valid is-invalid');
        $wrapper.addClass('is-validating');


        $this.attr('disabled', 'disabled');

        $wrapper.find('.searching-feedback').removeClass('d-none');

        $.ajax({
            url: url,
            type: 'get',
            success: function (data) {
                if (!data.valid) {
                    $this.closest('form').find(':submit').attr('disabled', 'disabled');
                    $this.removeAttr('disabled', 'disabled');
                    $wrapper.removeClass('is-validating is-valid');
                    $this.addClass('is-invalid');

                    if (data.message) {
                        $wrapper.find('.invalid-feedback').html(data.message);
                        $this.addClass('is-invalid');
                    }
                    if (data.didyoumean) {
                        $wrapper.find('.invalid-feedback').html(data.message);
                        $this.addClass('is-invalid');
                    }
                } else {
                    $this.removeAttr('disabled', 'disabled');
                    $wrapper.removeClass('is-validating is-invalid');
                    $wrapper.addClass('is-valid');
                    $this.closest('form').find(':submit').removeAttr('disabled');
                }
            },
            error: function () {
                $this.removeAttr('disabled', 'disabled');
                $wrapper.removeClass('is-validating is-invalid is-valid');
                $this.closest('form').find(':submit').removeAttr('disabled');
            },
            complete: function () {
                $wrapper.find('.searching-feedback').addClass('d-none');
            }
        });
        return false;
    });

    $('body').on('click', '.did-you-mean', function () {
        var $group = $(this).closest('.form-group');
        var $holder = $group.find('.did-you-mean-holder');

        $holder.val($(this).text());
        $holder.removeClass('is-invalid');

        $holder.removeAttr('disabled', 'disabled');
        $holder.parent().removeClass('is-validating is-invalid');
        $holder.parent().addClass('is-valid');
    });
};

login.register = function () {
    $(document).on('submit', 'form.registration', function (e) {
        var $form = $(this);
        e.preventDefault();
        var url = $form.attr('action');
        $form.spinner().start();


        $('form.registration').trigger('login:register', e);

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                $form.spinner().stop();
                if (!data.success) {
                    formValidation($form, data);
                    $form.find('.did-you-mean-wrapper').removeClass('is-valid');
                } else {
                    $(document).trigger('login:registered', data);
                    if (data.templateAndForm) {
                        updateLoginFlowHolder(data.templateAndForm.template);
                        const notification = require('../util/notification');
                        notification.createNotification(data.popupMessage, 'success');
                    } else {
                        location.href = data.redirectUrl;
                    }
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                }

                $form.spinner().stop();
            }
        });

        return false;
    });

    $(document).on('focusout', '#edit-form-birthday', function () {
        const parseDate = require('date-fns');
        var dateString = $('#edit-form-birthday').val();
        var dateUser = parseDate.parse(dateString, 'dd/MM/yyyy', new Date());
        if (parseDate.isValid(dateUser) && dateString.length === 10) {
            var date18YearsAgo = parseDate.subYears(new Date(), 18);
            date18YearsAgo = parseDate.format(date18YearsAgo, 'dd/MM/yyyy');
            date18YearsAgo = parseDate.parse(date18YearsAgo, 'dd/MM/yyyy', new Date());

            var year1700 = new Date(1700, 1, 1);

            if (parseDate.isAfter(date18YearsAgo, dateUser) && parseDate.isBefore(year1700, dateUser)) {
                $('#edit-form-birthday').removeClass('is-invalid');
                $('#form-birthday-error').html('');
            } else {
                $('#edit-form-birthday').addClass('is-invalid');
                if (!parseDate.isAfter(date18YearsAgo, dateUser)) {
                    $('#form-birthday-error').html($('#edit-form-birthday').data('message-agerestriction'));
                } else {
                    $('#form-birthday-error').html($('#edit-form-birthday').data('message-dateformat'));
                }
            }
        } else {
            $('#edit-form-birthday').addClass('is-invalid');
            $('#form-birthday-error').html($('#edit-form-birthday').data('message-dateformat'));
        }
    });
};

login.completeProfile = function () {
    $(document).on('submit', 'form.completion', function (e) {
        var $form = $(this);
        e.preventDefault();
        var url = $form.attr('action');
        $form.spinner().start();

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (!data.success) {
                    formValidation($form, data);

                    disableForm($form, false);
                    $form.spinner().stop();

                    $(this).delay(5000).queue(function () {
                        $('.alert-danger').remove();
                    });
                } else {
                    disableForm($form, true);
                    if (data.templateAndForm) {
                        updateLoginFlowHolder(data.templateAndForm.template);
                        if (data.templateAndForm.form === 'optinForm') {
                            $('#modalOptinInformation').modal('toggle');
                        }
                        const notification = require('../util/notification');
                        notification.createNotification(data.popupMessage, 'success');
                    } else {
                        var popup = require('../components/popup');
                        popup.setPopupCookie(data.popupMessage);
                        location.href = data.redirectUrl;
                    }
                }
            },
            error: function (data) {
                disableForm($form, false);

                if (data.responseJSON.redirectUrl) {
                    window.location.href = data.responseJSON.redirectUrl;
                } else {
                    $form.spinner().stop();

                    $(this).delay(5000).queue(function () {
                        $('.alert-danger').remove();
                    });
                }
            }
        });

        return false;
    });
};

login.showPassword = function () {
    $(document).on('click', '.password-toggle-icon', function () {
        const $input = $(this).siblings('input');
        const $icon = $(this).find('i');

        const newType = $input.attr('type') === 'password' ? 'text' : 'password';
        $input.attr('type', newType);
        $icon.toggleClass('fa-eye fa-eye-slash');
    });
};

module.exports = login;
